<div class="Section_PH">
    <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 res-bt">
            <!--
            <div class="container"><button class="up-btn" routerLink="/restaurant_dash/new_orders">New Orders</button>
            </div> -->
            <div class="container"><button class="up-btn" routerLink="/restaurant_dash/upcoming_orders">Upcoming
                    Orders</button></div>
            <div class="container"><button class="up-btn" routerLink="/restaurant_dash/completed_orders">Completed
                    Orders</button></div>
            <div class="container"><button class="new-btn" routerLink="/restaurant_dash/club_orders">Clubs
                    Profile</button>
            </div>

        </div>
    </div>
</div>